/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Channel({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M6.46 9.979a4.5 4.5 0 1 1 4.31-7.775" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M7.607 6.803a4.5 4.5 0 1 1 4.579 7.62" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M9.932 9.469a4.5 4.5 0 1 1-8.888.155" /></svg>;
}
;